import styled from 'styled-components'
export const Spacer = styled.div<{ $horizontal?: boolean; size: string }>`
  display: block;
  ${(props) => (props.$horizontal ? `width: ${props.size}; height: 1px` : `height: ${props.size}; width: 1px`)}
`
